// // // src/hooks/useClientGeoLocation.js
// // import { useEffect, useState } from 'react';

// // const STORAGE_KEY = 'client_geo_coords';

// // export function getStoredCoords() {
// //   try {
// //     const raw = localStorage.getItem(STORAGE_KEY);
// //     return raw ? JSON.parse(raw) : null;
// //   } catch {
// //     return null;
// //   }
// // }

// // function storeCoords(lat, lng) {
// //   localStorage.setItem(STORAGE_KEY, JSON.stringify({ lat, lng, ts: Date.now() }));
// // }

// // // Call this once near app root (e.g. inside your main Layout / App.js)
// // export function useClientGeoLocation() {
// //   const [permissionState, setPermissionState] = useState('prompt'); // 'granted' | 'denied' | 'prompt' | 'unsupported'

// //   const requestLocation = () => {
// //     if (!('geolocation' in navigator)) {
// //       setPermissionState('unsupported');
// //       return;
// //     }
// //     navigator.geolocation.getCurrentPosition(
// //       (pos) => {
// //         storeCoords(pos.coords.latitude, pos.coords.longitude);
// //         setPermissionState('granted');
// //       },
// //       (err) => {
// //         // err.code === 1 => PERMISSION_DENIED
// //         setPermissionState(err.code === 1 ? 'denied' : 'prompt');
// //       },
// //       { enableHighAccuracy: true, timeout: 8000, maximumAge: 5 * 60 * 1000 }
// //     );
// //   };

// //   useEffect(() => {
// //     if (!('permissions' in navigator)) {
// //       requestLocation(); // just ask directly, older browser
// //       return;
// //     }
// //     navigator.permissions.query({ name: 'geolocation' }).then((status) => {
// //       setPermissionState(status.state);
// //       if (status.state === 'granted') requestLocation();
// //       status.onchange = () => setPermissionState(status.state);
// //     });
// //   }, []);

// //   return { permissionState, requestLocation };
// // }

// import { useEffect, useState } from 'react';

// const STORAGE_KEY = 'client_geo_coords';

// export function getStoredCoords() {
//   try {
//     const raw = localStorage.getItem(STORAGE_KEY);
//     return raw ? JSON.parse(raw) : null;
//   } catch {
//     return null;
//   }
// }

// function storeCoords(lat, lng) {
//   try {
//     localStorage.setItem(STORAGE_KEY, JSON.stringify({ lat, lng, ts: Date.now() }));
//   } catch {
//     // localStorage unavailable (private mode etc) — non-fatal
//   }
// }

// /**
//  * Requests browser geolocation and persists it to localStorage so the
//  * axios interceptor can attach it to every request. Call this once near
//  * the app root (e.g. inside your main Layout / App.js).
//  */
// export function useClientGeoLocation() {
//   // 'granted' | 'denied' | 'prompt' | 'unsupported'
//   const [permissionState, setPermissionState] = useState('prompt');
//   const [error, setError] = useState(null);

//   const requestLocation = () => {
//     if (!('geolocation' in navigator)) {
//       setPermissionState('unsupported');
//       return;
//     }
//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         storeCoords(pos.coords.latitude, pos.coords.longitude);
//         setPermissionState('granted');
//         setError(null);
//       },
//       (err) => {
//         setPermissionState(err.code === 1 ? 'denied' : 'prompt');
//         setError(err.message);
//       },
//       { enableHighAccuracy: true, timeout: 8000, maximumAge: 5 * 60 * 1000 }
//     );
//   };

//   useEffect(() => {
//     if (!('permissions' in navigator)) {
//       requestLocation();
//       return;
//     }

//     let permStatus;
//     navigator.permissions.query({ name: 'geolocation' }).then((status) => {
//       permStatus = status;
//       setPermissionState(status.state);
//       if (status.state === 'granted') requestLocation();
//       status.onchange = () => {
//         setPermissionState(status.state);
//         if (status.state === 'granted') requestLocation();
//       };
//     });

//     return () => {
//       if (permStatus) permStatus.onchange = null;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return { permissionState, requestLocation, error };
// }


import { useEffect, useState } from 'react';

const STORAGE_KEY = 'client_geo_coords';

export function getStoredCoords() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function storeCoords(lat, lng) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ lat, lng, ts: Date.now() }));
  } catch {
    // localStorage unavailable (private mode etc) — non-fatal
  }
}

/**
 * Requests browser geolocation and persists it to localStorage so the
 * axios interceptor can attach it to every request. Call this once near
 * the app root (e.g. inside your main Layout / App.js).
 */
export function useClientGeoLocation() {
  // 'granted' | 'denied' | 'prompt' | 'unsupported'
  const [permissionState, setPermissionState] = useState('prompt');
  const [error, setError] = useState(null);

  const requestLocation = () => {
    if (!('geolocation' in navigator)) {
      setPermissionState('unsupported');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        storeCoords(pos.coords.latitude, pos.coords.longitude);
        setPermissionState('granted');
        setError(null);
      },
      (err) => {
        setPermissionState(err.code === 1 ? 'denied' : 'prompt');
        setError(err.message);
      },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 5 * 60 * 1000 }
    );
  };

  useEffect(() => {
    if (!('permissions' in navigator)) {
      requestLocation();
      return;
    }

    let permStatus;
    navigator.permissions.query({ name: 'geolocation' }).then((status) => {
      permStatus = status;
      setPermissionState(status.state);
      if (status.state === 'granted') requestLocation();

      // NOTE: onchange doesn't fire reliably across all browsers when the
      // permission is changed from browser site-settings UI (vs the native
      // prompt). Keep this as a best-effort live update; the banner also
      // offers a manual "refresh" fallback for when this doesn't fire.
      status.onchange = () => {
        setPermissionState(status.state);
        if (status.state === 'granted') requestLocation();
      };
    });

    return () => {
      if (permStatus) permStatus.onchange = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { permissionState, requestLocation, error };
}